import type { DataItem } from '@pn/core/domain/data';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type StatsAggregationType = 'sum' | 'avg' | 'median';

type CompanyStatsState = {
  isFetching: boolean;
  isFetchingAggregated: boolean;
  isError: boolean;
  loadedCompanyIds: string[];
  companyStats: Record<string, DataItem[]>;
  aggregatedStats: Record<string, DataItem[]>;
};

const initialState: CompanyStatsState = {
  isFetching: false,
  isFetchingAggregated: false,
  isError: false,
  loadedCompanyIds: [],
  companyStats: {},
  aggregatedStats: {},
};

const createCompanyStatsSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.isError = false;
      },
      requestAggregated: (state) => {
        state.isFetchingAggregated = true;
        state.isError = false;
      },
      receive: (
        state,
        action: PayloadAction<{
          loadedCompanyId: string;
          stats: DataItem[];
        }>
      ) => {
        state.companyStats[action.payload.loadedCompanyId] =
          action.payload.stats;
        state.loadedCompanyIds = [
          ...state.loadedCompanyIds,
          action.payload.loadedCompanyId,
        ];
        state.isFetching = false;
      },
      receiveAggregated: (
        state,
        action: PayloadAction<{
          aggregationType: StatsAggregationType;
          stats: DataItem[];
        }>
      ) => {
        state.aggregatedStats[action.payload.aggregationType] =
          action.payload.stats;
        state.isFetchingAggregated = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isFetchingAggregated = false;
        state.isError = true;
      },
      reset: (state) => {
        state.isFetching = false;
        state.isError = false;
        state.companyStats = {};
      },
    },
  });

export const companyQuarterlyCorporateStatsSlice = createCompanyStatsSlice(
  'companyQuarterlyCorporateStats'
);
export const companyMonthlyStatsSlice = createCompanyStatsSlice(
  'companyMonthlyStats'
);
